import React, { Fragment } from 'react';

import Hero from '../hero/Hero';
import Modal from '../modals/modal';
import TopTradingVolumes from "../topTradingVolumes/TopTradingVolumes";
import { ModalCusipUse } from '../modals/dataModals';
import { getLadingStats } from '../../utils/api';

class Home extends React.Component {
  constructor() {
    super();

    this.state = {
      heroData: {
        error: null,
        loading: true,
        totalPreviousDayDrsTraded: 0,
        totalPreviousDayVolume: 0,
        lastTradeDate: ''
      }
    };
  }

  componentDidMount() {
    if (this.isCusipAccepted()) {
      this.setState({ isAccepted: true });
    }
    getLadingStats()
      .then(({ totalPreviousDayDrsTraded, totalPreviousDayVolume, lastTradeDate }) => {
        this.setState({
          heroData: {
            loading: false,
            totalPreviousDayDrsTraded,
            totalPreviousDayVolume,
            lastTradeDate
          }
        })
      })
      .catch(() => {
        this.setState({
          heroData: {
            error: true,
            loading: false
          }
        })
      })
  }

  HomePageRender() {
    const { heroData } = this.state;

    return (
      <Fragment>
        <Hero {...heroData} />
        <TopTradingVolumes lastTradeDate={heroData.lastTradeDate} />
      </Fragment>
    );
  }

  isCusipAccepted() {
    return document.cookie.split('; ').some(cookie => cookie.startsWith('cusip_is_accepted=true'));
  }

  renderCusipUseDisclaimer() {
    return (
      <Modal
        title="CUSIP Use"
        onClickBtn={() => {              
          // Set a session cookie named 'cusip_is_accepted'
          document.cookie = `cusip_is_accepted=true; path=/`;
          this.setState({ isAccepted: true });
        }}
        requireAccept
      >
        <ModalCusipUse />
      </Modal>
    );
  }

  render() {
    const { isAccepted } = this.state;
    if (isAccepted) {
      return this.HomePageRender();
    } else {
      return this.renderCusipUseDisclaimer();
    }
  }
}

export default Home;
